exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"menuText": "#303133",
	"menuActiveText": "#90c328",
	"subMenuActiveText": "#303133",
	"menuBg": "#fff",
	"menuHover": "#ecf5ff",
	"subMenuBg": "#fff",
	"subMenuHover": "#ecf5ff",
	"sideBarWidth": "2rem",
	"webColor": "#ff6800"
};